export default "__VITE_ASSET__DqcP4IS3__"